import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _extends from 'babel-runtime/helpers/extends';

import { mapState, mapGetters } from 'vuex';
import { CustomEventType } from '@ps/bridge/qc/vp/config';
import _set from 'lodash/set';
import _get from 'lodash/get';
import { language } from '@/common/storage';
export default {
  props: {
    config: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    this.customEvent = _get(this.model, this.config.prop);
  },
  data: function data() {
    return {
      customEvent: null
    };
  },

  computed: _extends({}, mapState({
    activeNode: function activeNode(state) {
      return state.workspace.game.activeNode;
    }
  }), mapGetters({
    gamePlay: 'workspace/game/gamePlay'
  }), {
    customEventOptions: function customEventOptions() {
      var res = [];
      this.gamePlay.children.forEach(function (scene) {
        var ast = scene.getScript('playsmart.editor.data').vpAst;
        for (var i in ast) {
          if (ast[i].condition[0] && ast[i].condition[0].content === CustomEventType.CUSTOM_EVENT) {
            var customEventValue = {
              sceneUuid: scene.uuid,
              eventName: ast[i].eventName,
              eventNameEn: ast[i].eventNameEn
            };
            var lang = language.get();
            var evtName = '';
            if (lang === 'en') {
              evtName = ast[i].eventNameEn;
            } else {
              evtName = ast[i].eventName;
            }
            res.push({
              label: scene.uniqueName + ' : ' + evtName,
              value: _JSON$stringify(customEventValue)
            });
          }
        }
      });
      return res;
    }
  }),
  methods: {
    realProp: function realProp() {
      var index = this.config.prop.lastIndexOf('.');
      if (index === -1) {
        return this.config.prop;
      }
      return this.config.prop.slice(0, index);
    },
    customEventChangeHandler: function customEventChangeHandler(v) {
      var prop = this.realProp();
      _set(this.model.script, prop, v);
      _set(this.model, this.config.prop, v);
    }
  }
};